import React from "react";
import Icons from "../../../../config/images";
import "./AboutBACode.css";

const AboutBACode = () => {
  return (
    <section className="about-ba-code-section">
      <div className="about-ba-code-content">
        <h2>Who We Are</h2>
        <p>
          BA Code Solution is a technology-driven IT company specializing in
          custom web and mobile application development, with a strong focus on
          the jewellery industry. We help jewellery brands, retailers,
          wholesalers, and manufacturers transform their business through smart,
          scalable digital solutions.
        </p>

        <h3>What We Do</h3>
        <p>
          We design and develop tailor-made software solutions that align with
          real business workflows — from product catalogues and e-commerce
          platforms to complete Jewellery ERP systems with inventory management,
          invoicing, live rate integration, and secure role-based access.
        </p>
      </div>

      <div className="about-ba-code-img">
        <img src={Icons.aboutusImg} alt="About BA Code Solution" />
      </div>
    </section>
  );
};

export default AboutBACode;
